









import { Component, Vue } from 'vue-property-decorator';
import './breadcrumb.css';
@Component({})
export default class BreadcrumbComponent extends Vue {
    
    constructor() {
        super();
    }

    get current(){
        return this.$router.currentRoute.meta.label
    }
}

